import { useState, useEffect } from 'react';
import { isCampo } from './isCampo';
import { getDefaultConfig } from './siembraOptions';

export function useSiembraConfig(items) {
  const [pruebasConfig, setPruebasConfig] = useState({});

  useEffect(() => {
    const temp = {};
    items.forEach((item) => {
      const fieldEvent = isCampo(item);
      // si item.configSiembra ya existe, úsala, si no getDefaultConfig
      temp[item.id] = item.configSiembra || getDefaultConfig(fieldEvent);
    });
    setPruebasConfig(temp);
  }, [items]);

  const handleConfigChange = (itemId, field, value) => {
    setPruebasConfig((prev) => ({
      ...prev,
      [itemId]: {
        ...prev[itemId],
        [field]: value,
      },
    }));
  };

  return {
    pruebasConfig,
    handleConfigChange,
  };
}
